<template>
  <header class="main-header">
    <nav class="main-header__nav page-wrapper">
      <a
        :href="currentLocale === 'no' ? 'https://www.nor-way.no/' : 'https://www.nor-way.no/en/'"
        class="logo"
      >
        <svg>
          <use :xlink:href="`#${norWayLogo}`" />
        </svg>
      </a>
      <div class="main-header__links">
        <router-link
          class="main-header__link"
          to="/"
        >
          {{ $t('header.search') }}
        </router-link>
        <router-link
          class="main-header__link"
          :to="minSideRoute"
        >
          {{ $t('header.myPage') }}
        </router-link>
        <button
          v-if="isLoggedIn"
          class="main-header__link button--logout"
          @click="logout"
        >
          {{ $t('header.logout') }}
        </button>
        <LanguageSwitcher class="main-header__language-switcher" />
      </div>
    </nav>
  </header>
</template>

<script lang="ts">
  import { defineComponent, computed } from 'vue'
  import { useUserStore } from '@/stores/userStore'
  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import norWayLogo from '@/assets/icons/nor-way-logo.svg'
  import LanguageSwitcher from './LanguageSwitcher.vue'

  export default defineComponent({
    name: 'Header',
    components: {
      LanguageSwitcher,
    },
    setup() {
      const userStore = useUserStore()
      const router = useRouter()
      const { locale: currentLocale } = useI18n()

      const isLoggedIn = computed(() => userStore.isLoggedIn)

      const minSideRoute = computed(() => {
        return isLoggedIn.value ? '/min-side/brukerinformasjon' : '/login'
      })

      const logout = () => {
        userStore.logout()
        router.push('/login')
      }

      return {
        isLoggedIn,
        minSideRoute,
        logout,
        norWayLogo,
        currentLocale,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .main-header {
    height: 68px;
    width: 100%;
    background-color: #fff;
    box-shadow: inset 0 -2px 4px 0 rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    z-index: 15;

    &__nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      padding-right: 16px;
      padding-left: 16px;
    }

    &__links {
      display: flex;
      gap: 2px;

      @media screen and (min-width: $breakpoint-xs) {
        gap: 16px;
      }
    }

    &__link {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      padding: 8px;
      text-decoration: none;
      text-align: center;
      background-color: $clr-white;
      border-radius: 4px;

      @media screen and (min-width: $breakpoint-xs) {
        padding-top: 12px;
        padding-bottom: 12px;
      }

      &:hover {
        background-color: $clr-background;
      }
    }

    &__language-switcher {
      margin-left: 1rem;
    }
    .logo {
      svg {
        width: 128px;
        height: 22px;
      }
    }

    .button--logout {
      font: inherit;
      border: none;
      color: inherit;
      cursor: pointer;

      &:hover {
        background-color: $clr-warning-100;
      }
    }
  }
</style>
